// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__C9vZp","banner__image":"Banner_banner__image__MkROa","banner__title":"Banner_banner__title__7I-NQ"};